export const iconFontAwesomeHumanitarianMountainSun = (
	<i className="fa-solid fa-mountain-sun"></i>
);
